var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _g2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g3, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunrise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "596.63px",
    height: "276px",
    viewBox: "228.703 253.13 596.63 276",
    enableBackground: "new 228.703 253.13 596.63 276",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M548.078,313.781l1.833-20.984l1.984,0.172l-1.833,20.99L548.078,313.781z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M548.755,328.318l-1.989-0.188l-1.958,22.563h1.958L548.755,328.318z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M568.703,310.688l3.688-21.26l1.948,0.338l-3.688,21.26L568.703,310.688z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M569.703,324.083l-1.964-0.339l-5.135,29.188l1.963,0.313L569.703,324.083z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M598.067,289.995l6.162-23.031l1.927,0.516l-6.167,23.026L598.067,289.995z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M591.692,313.677l2.115-7.912l1.927,0.516l-2.12,7.906L591.692,313.677z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M590.427,326.047l-1.927-0.531l-8.344,31.12l1.901,0.531L590.427,326.047z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M627.063,280.188l8.677-23.865l1.875,0.677l-8.682,23.865L627.063,280.188z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M622.979,297.198l-1.865-0.688l-23.838,65.542l1.864,0.656L622.979,297.198z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M642.438,307.521l10.026-21.49l1.807,0.838l-10.025,21.495L642.438,307.521z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M637.422,323.057l-1.808-0.838l-21.786,46.682l1.808,0.839L637.422,323.057z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M672.958,302.281l12.672-21.932l1.729,0.995l-12.677,21.932L672.958,302.281z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M640.406,358.698l23.896-41.359l1.725,0.995l-23.896,41.364L640.406,358.698z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M636.672,369.151l-1.708-0.875l-4.979,8.745l1.708,1L636.672,369.151z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M672.13,347.802l12.594-17.964l1.631,1.141l-12.594,17.969L672.13,347.802z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M665.177,361.276l-1.646-1.12l-18.516,26.453l1.614,1.119L665.177,361.276z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M713.719,332.672l16.188-19.281l1.526,1.281l-16.188,19.281L713.719,332.672z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M704.141,347.115l-1.526-1.276l-43.317,51.63l1.526,1.276L704.141,347.115z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M719.719,362.385l16.703-16.703l1.406,1.406l-16.703,16.703L719.719,362.385z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M673.984,410.942l35.698-35.724l-1.401-1.401l-35.698,35.729L673.984,410.942z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M744.547,372.479l18.854-15.828l1.281,1.526l-18.854,15.828L744.547,372.479z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M732.927,384.865l-1.275-1.527l-46.896,39.37l1.245,1.589L732.927,384.865z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M764.958,388.459l20.62-14.449l1.146,1.63l-20.619,14.447L764.958,388.459z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M751.974,399.927l-1.119-1.619l-55.084,38.438l1.12,1.619L751.974,399.927z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M751.136,425.63l19.411-11.197l0.995,1.724l-19.406,11.198L751.136,425.63z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M716.484,445.583l21.349-12.322l0.995,1.724l-21.344,12.328L716.484,445.583z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M755.021,451l19.678-8.969l0.828,1.813l-19.683,8.969L755.021,451z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M740.958,457.38l-0.838-1.807l-26.115,12.291l0.844,1.776L740.958,457.38z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M805.604,453.5l24.13-8.776l0.683,1.875l-24.131,8.776L805.604,453.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M722.792,483.63l66.328-24.141l0.677,1.87L723.474,485.5L722.792,483.63z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M766.526,490.667l20.744-5.558l0.516,1.922l-20.744,5.558L766.526,490.667z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M752.844,496.406l-0.495-1.933l-25.896,6.975c0.156,0.65,0.344,1.275,0.5,1.927L752.844,496.406z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M795.354,507.521l23.234-4.099l0.344,1.958l-23.229,4.104L795.354,507.521z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M779.828,512.214l-0.344-1.928l-49.234,8.683c0,0.62,0.219,1.276,0.344,1.927L779.828,512.214z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 800,
    y: 528,
    width: 25.333,
    height: 1.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M800.5,530.817l23.656-2.072l0.172,1.984l-23.651,2.072L800.5,530.817z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 232,
    y: 528,
    width: 26.667,
    height: 1.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M232.245,530.781l0.177-1.984l26.167,2.292l-0.177,1.984L232.245,530.781z"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M295.162,515.594l0.344-1.964l25.651,4.531l-0.344,1.959L295.162,515.594z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M257.412,508.989l0.349-1.963l23.901,4.213l-0.344,1.964L257.412,508.989z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M270.427,487.703l0.516-1.922l55.25,14.802l-0.516,1.928L270.427,487.703z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M228.703,476.516l0.516-1.922l26.453,7.089l-0.516,1.922L228.703,476.516z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M313.083,476.422l-0.688,1.839l21.787,7.969l0.65-1.87L313.083,476.422z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M277.458,465.578l0.677-1.87l22.141,8.058l-0.682,1.87L277.458,465.578z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M321.891,458.531l-0.844,1.802l19.922,9.339l0.839-1.776L321.891,458.531z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M287.604,444.714l0.844-1.803l21.235,9.901l-0.839,1.808L287.604,444.714z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M286.896,417.667l0.995-1.725l51.667,29.828l-0.995,1.725L286.896,417.667z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M247.885,395.141l1-1.729l24.74,14.286l-0.995,1.724L247.885,395.141z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M326.808,413.651l-1.151,1.619l33.172,23.219c0.375-0.531,0.75-1.094,1.151-1.619L326.808,413.651z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M292.932,392.344l1.141-1.631l20.755,14.532l-1.146,1.63L292.932,392.344z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M316.469,379.573l1.281-1.526l45.271,37.984l-1.281,1.526L316.469,379.573z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M282.255,350.838l1.281-1.526l21.667,18.182l-1.276,1.526L282.255,350.838z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M383.167,409.547l-10.053-10.146l-1.4,1.396l10.052,10.052L383.167,409.547z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M345.323,374.516l1.411-1.412l19.516,19.521l-1.406,1.406L345.323,374.516z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M315.844,345.005l1.411-1.412l18.703,18.708l-1.406,1.406L315.844,345.005z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M381.016,379.141l-1.521,1.276l15.4,18.329l1.495-1.276L381.016,379.141z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M355.589,351.865l1.525-1.276l15.183,18.094l-1.526,1.281L355.589,351.865z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M388.364,354.677l-1.619,1.12l22.281,31.932l1.619-1.119L388.364,354.677z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M363.823,323.984l1.63-1.141l14.438,20.625l-1.63,1.141L363.823,323.984z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M399.192,330.932l-1.713,0.995l26.703,46.245l1.713-0.995L399.192,330.932z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M376.458,295.375l1.725-0.995l13.322,23.067l-1.729,1L376.458,295.375z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M428.786,340.828l-1.802,0.838l13.067,28.011l1.776-0.839L428.786,340.828z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M410.755,306.88l1.808-0.839l10.286,22.052l-1.807,0.844L410.755,306.88z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M442.229,323.292l1.869-0.677l10.401,28.567l-1.875,0.683L442.229,323.292z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M432.317,295.984l1.87-0.682l6.141,16.875l-1.87,0.682L432.317,295.984z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 416,
    y: 253.13,
    width: 13.333,
    height: 28.203
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M416.948,253.802l1.869-0.683l9.729,26.729l-1.875,0.682L416.948,253.802z"
  })))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M469.12,332.552l-1.928,0.526l6.469,24.151l1.933-0.531L469.12,332.552z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M457.542,296.917l1.927-0.516l6.136,22.906l-1.922,0.516L457.542,296.917z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M489.067,329.875l-1.958,0.338l4.073,23.031l1.932-0.313L489.067,329.875z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M479.167,294.422l1.953-0.338l4.005,23.088l-1.953,0.338L479.167,294.422z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M506.183,296.354h-1.99l4.761,54.495h1.995L506.183,296.354z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M500.505,254.448l1.984-0.172l2.334,26.662l-1.984,0.172L500.505,254.448z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M528.87,350.01v-43.292h-1.99v43.292H528.87z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M526.88,266.323h1.99v25.615h-1.99V266.323z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 328,
    y: 356,
    width: 400,
    height: 173.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_8_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECA73F",
    d: "M626.87,728.974l1.682-0.994c4.438-2.615,8.787-5.386,13.037-8.313l1.588-1.12 c4.203-3.109,8.308-6.224,12.261-9.333l1.495-1.245c3.922-3.333,7.75-6.817,11.391-10.458l1.369-1.37 c7.734-7.797,14.781-16.183,21.131-25.146l1.119-1.589c6.266-9.031,11.75-18.511,16.464-28.442 c0.25-0.594,0.526-1.151,0.808-1.745c2.146-4.667,4.141-9.333,5.942-14.313l0.656-1.808c1.724-4.854,3.266-9.781,4.636-14.781 c0-0.625,0.344-1.213,0.5-1.838c1.307-4.979,2.427-10.021,3.359-15.125c0-0.651,0.188-1.276,0.313-1.896 c0.869-5.072,1.525-10.177,1.989-15.375l0.188-1.9c0.438-5.433,0.656-10.912,0.656-16.428c0-5.521-0.219-11-0.656-16.432 l-0.188-1.933c-0.464-5.167-1.12-10.302-1.989-15.344c0-0.651-0.219-1.276-0.313-1.896c-0.933-5.125-2.053-10.167-3.359-15.125 c-0.156-0.625-0.344-1.245-0.5-1.87c-2.901-10.604-6.646-20.906-11.234-30.901c-0.281-0.563-0.558-1.15-0.808-1.744 c-2.239-4.667-4.604-9.334-7.156-13.725c-0.344-0.563-0.656-1.119-1-1.65c-2.583-4.479-5.38-8.839-8.308-13.068l-1.119-1.588 c-3.115-4.203-6.225-8.308-9.339-12.261l-1.245-1.464c-3.317-3.942-6.802-7.75-10.453-11.422l-1.369-1.369 c-3.641-3.609-7.469-7.125-11.391-10.459l-1.495-1.244c-3.953-3.297-8.058-6.442-12.261-9.333l-1.588-1.09 c-4.146-2.947-8.495-5.729-13.037-8.343l-1.682-0.963c-4.448-2.583-9.058-4.948-13.725-7.156l-1.932-0.875 c-4.667-2.177-9.334-4.167-14.313-5.943l-1.808-0.651c-4.854-1.745-9.781-3.302-14.781-4.672l-1.833-0.495 c-4.979-1.308-10.021-2.427-15.125-3.333l-1.933-0.463c-5.073-0.844-10.177-1.526-15.37-1.995h-1.9 c-5.104-0.432-10.271-0.651-15.563-0.682h-1.928c-5.197,0-10.364,0.25-15.563,0.682h-1.927 c-5.167,0.469-10.302,1.151-15.344,1.995l-1.896,0.338c-5.136,0.906-10.178,2.026-15.125,3.333l-1.87,0.495 c-10.521,2.953-20.729,6.75-30.62,11.391l-1.744,0.813c-4.698,2.208-9.334,4.573-13.756,7.156l-1.646,0.963 c-4.484,2.615-8.839,5.396-13.073,8.343l-1.557,1.09c-4.229,3.109-8.308,6.224-12.448,9.333l-1.464,1.244 c-3.947,3.334-7.744,6.85-11.422,10.459l-1.364,1.369c-7.729,7.808-14.776,16.188-21.136,25.146l-1.088,1.588 c-6.281,9.021-11.766,18.506-16.464,28.443l-0.808,1.744c-2.177,4.698-4.141,9.334-5.942,14.313l-0.656,1.808 c-5.692,15.88-9.302,32.219-10.828,49.016c0,0.656,0,1.276-0.156,1.933c-0.433,5.411-0.683,10.891-0.683,16.432 c0,5.537,0.25,10.984,0.683,16.433c0,0.62,0,1.276,0.156,1.896c0.469,5.198,1.151,10.303,2.021,15.375 c0,0.62,0.188,1.245,0.313,1.896c0.901,5.104,2.026,10.146,3.334,15.125c0.15,0.625,0.338,1.213,0.494,1.838 c2.959,10.573,6.766,20.834,11.422,30.776c0.25,0.594,0.531,1.156,0.808,1.745c2.203,4.666,4.589,9.244,7.161,13.724l0.964,1.683 c8.516,14.541,18.698,27.802,30.558,39.771c0.469,0.469,0.906,0.938,1.369,1.37c7.813,7.739,16.203,14.781,25.178,21.13 l1.557,1.125c9.042,6.261,18.537,11.75,28.475,16.458l1.744,0.813c9.984,4.589,20.271,8.334,30.87,11.234l1.87,0.5 c4.958,1.303,10,2.428,15.125,3.359l1.896,0.313c5.042,0.839,10.177,1.521,15.344,1.99l1.927,0.188 c5.104,0.406,10.271,0.619,15.563,0.65h1.928c5.197,0,10.364-0.244,15.563-0.65l1.896-0.188c5.198-0.469,10.302-1.151,15.375-1.99 l1.901-0.313c5.099-0.932,10.141-2.057,15.119-3.359l1.839-0.5c10.609-2.9,20.911-6.646,30.901-11.234l1.744-0.813 C617.75,733.891,622.359,731.526,626.87,728.974z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.08373, 15.650029)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.105cc7f15419eccaea74992757aa1b0c.svg";
export { ForwardRef as ReactComponent };